"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignaturesByAlgorithm = void 0;
const fs_1 = require("fs");
const dubhash_1 = require("./dubhash");
const uhash_1 = require("./uhash");
const pMap = require("p-map");
const { readFile } = fs_1.promises;
async function getSignaturesByAlgorithm(filePaths, hashType = 'dubhash') {
    if (hashType !== 'dubhash' && hashType !== 'uhash') {
        throw new Error(`Unsupported hashType ${hashType}`);
    }
    let signatureMapperToBeUsed = getDubHashSignatureMapper;
    if (hashType === 'uhash') {
        signatureMapperToBeUsed = getUHashSignatureMapper;
    }
    return await pMap(filePaths, signatureMapperToBeUsed, { concurrency: 20 });
}
exports.getSignaturesByAlgorithm = getSignaturesByAlgorithm;
async function getDubHashSignatureMapper(filePath) {
    const fileContents = await readFile(filePath);
    if (fileContents.length === 0)
        return null;
    return dubhash_1.getDubHashSignature(filePath, fileContents);
}
async function getUHashSignatureMapper(filePath) {
    const fileContents = await readFile(filePath);
    if (fileContents.length === 0)
        return null;
    return uhash_1.getUhashSignature(filePath, fileContents);
}
//# sourceMappingURL=signatures.js.map